<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/accountParentList' }">账户上级</el-breadcrumb-item>
                <el-breadcrumb-item>账户上级{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="submitApproval('submitForm')" :loading="btnLoading">保存并提交</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'parent_rid'"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="type == 'update' && item['prop'] == 'code'"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, checkNumber, processColDataToEdit } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'accountParentEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.type = 1;
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                type: {
                    request_uri: 'dropdownAccountParentType',
                    title: '类型',
                    ref: 'type_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                account_rid: {
                    request_uri: 'searchAccounts',
                    title: '账户',
                    ref: 'account_rid_ref',
                    default_option_key: 'account_option',
                    type: 'search_select'
                },
                parent_rid: {
                    request_uri: 'searchAccounts',
                    title: '上级账户',
                    ref: 'parent_rid_ref',
                    default_option_key: 'parent_option',
                    type: 'search_select'
                }
            };
        },
        initFormRule() {
            this.rules = {
                account_rid: [{ required: true, message: '请输入账户搜索', trigger: 'blur' }],
                parent_rid: [{ required: true, message: '请输入上级账户搜索', trigger: 'blur' }],
                type: [{ required: true, message: '请选择类型', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id || '';
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                type: this.data.type || '1',
                account_rid: this.data.account_rid || '',
                parent_rid: this.data.parent_rid || '',
                account_option: { rid: this.data.account_rid || '', name: this.data.account || '' },
                parent_option: { rid: this.data.parent_rid || '', name: this.data.parent || '' }
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('dataList')).account_parent;
            processColDataToEdit(
                temp,
                this,
                {
                    white: []
                },
                {
                    type_label: 'type',
                    account: 'account_rid',
                    parent: 'parent_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/accountParentList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .accountParentDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;

                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.formData.approval_status = 1; // 草稿
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        // 保存并提交
        submitApproval(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.formData.approval_status = 2; // 审核中
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'accountParentUpdate';
            } else {
                uri = 'accountParentInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>